// extracted by mini-css-extract-plugin
export default {"main":"styles_main__yuRzM","ui-spin":"styles_ui-spin__mhA6u"};